angular.module('TetherApp').factory('navService', [
    '$http',
    function ($http) {
        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getUsersClients = function () {
            let uri = '/api/v1/clients/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let getUnreadCount = function (data) {
            return $http.get('/api/notification-stats', {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' },
                params: data
            }).then(function (response) {
                return response.data;
            });
        };

        let setClient = function (clientId, clientName) {
            let uri = '/api/v1/clients/switcher/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.post(
                uri,
                {
                    client_id: clientId,
                    client_name: clientName
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            getUsersClients: getUsersClients,
            getUnreadCount: getUnreadCount,
            setClient: setClient
        }

    }
]);
